export const aiPrompts = [
  "What can you tell me about this log?",
  "What tests failed in my task?",
  "Is this the first time this task has failed?",
  "Are my tasks flaky?",
  "How do I fix this failure?",
  "What can you do?",
];
